import request from '@/utils/request'

export function getQuotations(param) {

  const data = param
  
  return request({
    url: `/zdmin/home0000/getQuotations`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    },
    data
  })

}

export function getPI(param) {

  const data = param
  
  return request({
    url: `/zdmin/home0000/getPI`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    },
    data
  })
  
}

export function getBidding(param) {

  const data = param
  
  return request({
    url: `/zdmin/home0000/getBidding`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    },
    data
  })
  
}

export function getNoticeList() {

  return request({
    url: `/zdmin/home0000/getNoticeList`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    }
  })

}

export function getBuyerList() {

  return request({
    url: `/zdmin/home0000/getBuyerList`,
    method: 'POST',
    meta: {
      apiVersion: '1.0.0'
    },
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    }
  })

}